"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var format_1 = require("./utils/format");
var NO_DATA_PLACEHOLDER = format_1.HYPHEN;
var SMALLEST_HEIGHT = 54;
var KpiValue = /** @class */ (function (_super) {
    tslib_1.__extends(KpiValue, _super);
    function KpiValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KpiValue.prototype.getKpiValueClassNames = function () {
        return classnames_1.default("kpi-value", {
            "is-smallest-height": this.props.enableCompactSize &&
                this.props.clientHeight &&
                this.props.clientHeight < SMALLEST_HEIGHT,
            "is-error-value": !this.props.isLoading && !!this.props.error,
            "is-empty-value": !this.props.isLoading && this.isValueUnhandledNull(),
        });
    };
    KpiValue.prototype.getKpiCustomHeightStyles = function () {
        if (this.props.enableCompactSize) {
            var height = sdk_ui_vis_commons_1.calculateHeadlineHeightFontSize(this.props.hasComparison, this.props.clientHeight).height;
            return {
                height: height + "px",
                lineHeight: height + "px",
            };
        }
        return undefined;
    };
    KpiValue.prototype.render = function () {
        if (this.props.enableCompactSize && !this.props.clientHeight) {
            return null;
        }
        return (react_1.default.createElement(react_transition_group_1.TransitionGroup, { style: this.getKpiCustomHeightStyles(), className: this.getKpiValueClassNames() },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: "kpi-animation", timeout: 300, title: this.getTitle() }, this.renderValue())));
    };
    KpiValue.prototype.renderValue = function () {
        var _a = this.props, isLoading = _a.isLoading, error = _a.error, disableKpiDrillUnderline = _a.disableKpiDrillUnderline, enableCompactSize = _a.enableCompactSize, clientHeight = _a.clientHeight, intl = _a.intl;
        if (isLoading) {
            return react_1.default.createElement(sdk_ui_kit_1.LoadingDots, { className: "kpi-value-loading gd-loading-dots-centered" });
        }
        var value = error ? intl.formatMessage({ id: "error" }) : this.renderFormattedValue();
        var valueClassNames = classnames_1.default("kpi-value-value", "s-kpi-value", {
            "kpi-link-style-underline": !disableKpiDrillUnderline,
        });
        if (enableCompactSize) {
            // As clientHeight first render returns undefined, need to wait to have correct value
            // so we can adjust fontSize and make the calculations accordingly.
            if (!clientHeight) {
                return react_1.default.createElement(sdk_ui_kit_1.LoadingDots, { className: "kpi-value-loading gd-loading-dots-centered" });
            }
            var fontSize = sdk_ui_vis_commons_1.calculateHeadlineHeightFontSize(this.props.hasComparison, clientHeight).fontSize;
            return (react_1.default.createElement("div", { style: { fontSize: fontSize + "px" } },
                react_1.default.createElement(sdk_ui_kit_1.ResponsiveText, null,
                    react_1.default.createElement("span", { className: valueClassNames }, value))));
        }
        return (react_1.default.createElement(sdk_ui_kit_1.ResponsiveText, null,
            react_1.default.createElement("span", { className: valueClassNames }, value)));
    };
    KpiValue.prototype.renderFormattedValue = function () {
        var _a;
        if (this.isValueUnhandledNull()) {
            return NO_DATA_PLACEHOLDER;
        }
        return format_1.formatMetric((_a = this.props.value) !== null && _a !== void 0 ? _a : null, this.props.format, this.props.separators);
    };
    KpiValue.prototype.isValueUnhandledNull = function () {
        var _a;
        return format_1.isValueUnhandledNull(this.props.value, (_a = this.props.format) !== null && _a !== void 0 ? _a : "");
    };
    KpiValue.prototype.getTitle = function () {
        var intl = this.props.intl;
        if (this.props.isLoading) {
            return "";
        }
        if (this.props.error && this.props.errorHelp) {
            return this.props.errorHelp;
        }
        if (this.isValueUnhandledNull()) {
            return intl.formatMessage({ id: "kpi.noData" });
        }
        return "";
    };
    KpiValue.defaultProps = {
        error: null,
        value: "",
        isLoading: false,
        disableKpiDrillUnderline: false,
    };
    return KpiValue;
}(react_1.PureComponent));
exports.default = react_intl_1.injectIntl(KpiValue);
//# sourceMappingURL=KpiValue.js.map